module.exports = __webpack_public_path__ + "static/worker-find-work-8a34232225b3fb3adebdffb80a05bc27.png";